import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import style from './order-import-mappings-delete-modal.module.less';

export const OrderImportMappingsDeleteModal = ({ modalFrameworkMethods: { closeModal }, mappingName, deleteSavedMapping }) => {
  const confirmationSequence = () => {
    deleteSavedMapping(mappingName);
    closeModal();
  };

  return (
    <Modal size='medium'>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage defaultMessage='Delete Mapping' description='Title for the delete mapping modal' id='vlfGdv' />
      </ModalHeader>
      <ModalBody className={style['order-import-mappings-delete-modal-body']}>
        <FormattedMessage
          defaultMessage='Are you sure you want to delete the mapping "{mappingName}"?'
          description='Confirmation message for deleting a mapping'
          id='w+DLJ9'
          values={{ mappingName }}
        />
      </ModalBody>

      <ModalFooter className={style['order-import-modal-footer']}>
        <div className={style['button-group']}>
          <Button onClick={closeModal} theme='tertiary'>
            <FormattedMessage defaultMessage='Cancel' description='Cancel button for the delete mapping modal' id='hZclCK' />
          </Button>
          <Button onClick={confirmationSequence} theme='primary'>
            <FormattedMessage defaultMessage='Delete' description='Delete button for the delete mapping modal' id='ZtCJ8M' />
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

OrderImportMappingsDeleteModal.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  mappingName: PropTypes.string.isRequired,
  deleteSavedMapping: PropTypes.func.isRequired,
};
